var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col gap-6"
  }, [_c('div', {
    staticClass: "bg-white shadow-md rounded-md p-4 flex flex-col gap-4"
  }, [_c('div', {
    staticClass: "text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.senderAddress')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": _vm.$t('order.createOrder.stepOne.senderAddressPlaceholder')
    },
    on: {
      "input": function input($event) {
        return _vm.searchSenderAddress($event, 'senderAddress');
      }
    },
    model: {
      value: _vm.tempOrderDetail.sender_address,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "sender_address", $$v);
      },
      expression: "tempOrderDetail.sender_address"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching['senderAddress'] ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion['senderAddress'] ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.addresses ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll shadow-base"
  }, _vm._l(_vm.addresses, function (address, index) {
    return _c('li', {
      key: 'address-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300 ",
      on: {
        "click": function click($event) {
          return _vm.selectSenderAddress(address, 'senderAddress');
        }
      }
    }, [_vm._v(" " + _vm._s(address.location_label) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepOne.dataNotFound')) + " ")])]) : _vm._e()])], 1)]), _c('TextField', {
    attrs: {
      "type": "text",
      "label": _vm.$t('order.createOrder.stepOne.receiverName'),
      "placeholder": _vm.$t('order.createOrder.stepOne.receiverNamePlaceholder')
    },
    model: {
      value: _vm.tempOrderDetail.receiver_name,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "receiver_name", $$v);
      },
      expression: "tempOrderDetail.receiver_name"
    }
  }), _c('TextField', {
    attrs: {
      "type": "text",
      "label": _vm.$t('order.createOrder.stepOne.receiverPhone'),
      "placeholder": _vm.$t('order.createOrder.stepOne.receiverPhonePlaceholder')
    },
    on: {
      "keypress": _vm.numbersOnly
    },
    model: {
      value: _vm.tempOrderDetail.receiver_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "receiver_phone", $$v);
      },
      expression: "tempOrderDetail.receiver_phone"
    }
  }), _c('div', {
    staticClass: "text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.receiverDistrict')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": _vm.$t('order.createOrder.stepOne.receiverDistrictPlaceholder')
    },
    on: {
      "input": function input($event) {
        return _vm.searchCity($event, 'destination');
      }
    },
    model: {
      value: _vm.destinationSearch,
      callback: function callback($$v) {
        _vm.destinationSearch = $$v;
      },
      expression: "destinationSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching['destination'] ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion['destination'] ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300 ",
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'destination');
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepOne.dataNotFound')) + " ")])]) : _vm._e()])], 1)]), _c('Textarea', {
    attrs: {
      "label": _vm.$t('order.createOrder.stepOne.receiverAddress'),
      "placeholder": _vm.$t('order.createOrder.stepOne.receiverAddressPlaceholder')
    },
    model: {
      value: _vm.tempOrderDetail.receiver_address,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "receiver_address", $$v);
      },
      expression: "tempOrderDetail.receiver_address"
    }
  }), _c('div', {
    staticClass: "custom-select"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.packageType')))]), _c('v-select', {
    attrs: {
      "options": _vm.goodsCategories,
      "placeholder": _vm.$t('order.createOrder.stepOne.packageTypePlaceholder'),
      "reduce": function reduce(selectedPackage) {
        return selectedPackage.code;
      },
      "label": "name"
    },
    model: {
      value: _vm.tempOrderDetail.goods_category,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "goods_category", $$v);
      },
      expression: "tempOrderDetail.goods_category"
    }
  })], 1), _c('TextField', {
    attrs: {
      "label": 'Berat (kg)'
    },
    model: {
      value: _vm.tempOrderDetail.goods_weight,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "goods_weight", $$v);
      },
      expression: "tempOrderDetail.goods_weight"
    }
  }), _c('div', {
    staticClass: "grid grid-cols-3 gap-4"
  }, [_c('TextField', {
    attrs: {
      "label": 'Panjang (cm)'
    },
    model: {
      value: _vm.tempOrderDetail.goods_length,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "goods_length", $$v);
      },
      expression: "tempOrderDetail.goods_length"
    }
  }), _c('TextField', {
    attrs: {
      "label": 'Lebar (cm)'
    },
    model: {
      value: _vm.tempOrderDetail.goods_width,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "goods_width", $$v);
      },
      expression: "tempOrderDetail.goods_width"
    }
  }), _c('TextField', {
    attrs: {
      "label": 'Tinggi (cm)'
    },
    model: {
      value: _vm.tempOrderDetail.goods_height,
      callback: function callback($$v) {
        _vm.$set(_vm.tempOrderDetail, "goods_height", $$v);
      },
      expression: "tempOrderDetail.goods_height"
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Harga Barang (Rp) ")]), _c('CurrencyInput', {
    attrs: {
      "options": {
        currency: 'IDR'
      },
      "value": _vm.tempOrderDetail.goods_value,
      "placeholder": _vm.$t('order.createOrder.stepTwo.goodsValuePlaceholder')
    },
    on: {
      "change": function change($event) {
        _vm.tempOrderDetail.goods_value = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.deliveryService')))]), _c('div', {
    staticClass: "relative"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tempOrderDetail.delivery_service_code,
      expression: "tempOrderDetail.delivery_service_code"
    }],
    staticClass: "border rounded-lg p-2 w-full",
    attrs: {
      "id": "deliveryService"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.tempOrderDetail, "delivery_service_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("-- Please choose a service --")]), _vm._l(_vm.deliveryServiceCodes, function (service) {
    return _c('option', {
      key: service,
      domProps: {
        "value": service
      }
    }, [_vm._v(" " + _vm._s(service) + " ")]);
  })], 2)])]), _c('Button', {
    attrs: {
      "buttonText": _vm.isLoadingEdit ? 'Saving...' : 'Edit',
      "disabled": _vm.isLoadingEdit,
      "isLoading": _vm.isLoadingEdit
    },
    on: {
      "action": _vm.submitForm
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }